// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------

import Globais, { validateToken } from "../components/Globais";
// --------------------- Import Interface ---------------------

export const verificarPermissao = async (
  tipo: ("ADMINISTRADOR"|"OPERADOR"|"PROPRIETARIO"),
) => {
  const Token = validateToken();
  if (Token) {
    switch (tipo) {
      case "ADMINISTRADOR": 
      switch (Token.nda) {
        case 0:
        case 2:
          document.location.href = '/login';
          return false;
        case 1:
          return true;
       }
       break;
      case "OPERADOR":
        switch (Token.nda) {
        case 0:
          document.location.href = '/login';
          return false;
        case 1:
        case 2:
          return true;
       }
       break;
      case "PROPRIETARIO":
        switch (Token.nda) {
        case 1:
        case 2:
          document.location.href = '/login';
          return false;
        case 0:
          return true;
       }
       break;

    }
    
  }else{
    document.location.href = '/login';
  }
};
